<template>
    <div class="TP--container">
        <div class="TP">
            <div class="TP--comment" v-if="step">
                <p class="TP--comment--text">{{ getCommentText }}</p>
                <p class="TP--comment--foot">{{ `-${getCommentAuthor}, ${getCommentDate}`}}</p>
            </div>
            <div class="TP--widget">
                <div ref="trustBoxRef" class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="596ca0ad0000ff0005a6d68d" data-style-height="50px" data-style-width="100%" data-theme="light">
                    <a href="" target="_blank" rel="noopener"></a>
                </div>
            </div>
        </div>
       <div class="TP--background-container">
            <img class="TP--background-image--desktop" src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/homepage/PAPER-BACKGROUND-DESKTOP.png" alt="Paper background" />
            <img class="TP--background-image--mobile" src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/homepage/PAPER-BACKGROUND-MOBILE.png" alt="Paper background"  />
        </div>
    </div>
</template>

<script>
import customerReviews from '@/content/customerTrustPilotReviews.json';

export default {
    name: 'TrustPilotReview',
    props: {
        step: {
            type: String,
            require: false,
            default: null,
        },
    },
    mounted() {
        window.Trustpilot.loadFromElement(this.$refs.trustBoxRef, true);
    },
    computed: {
        getCommentText() {
            return customerReviews.registrationSteps[this.step].review;
        },
        getCommentDate() {
            return customerReviews.registrationSteps[this.step].date;
        },
        getCommentAuthor() {
            return customerReviews.registrationSteps[this.step].name;
        },
    },
};
</script>

<style lang="scss" scoped>

.TP--container{
    position: relative;
    text-align: center;
}

.TP {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 80%;
    margin: 0 10%;
    height: 100%;
    &--comment {
        margin: 1rem;
        &--text {
            text-align: center;
        }
        &--foot {
            text-align: center;
            font-family: 'FreddiesFlowersTitle';
        }
    }
    &--widget {
        margin: 1rem;
    }

    &--background-image {
        &--desktop {
            display: none;
        }
        &--mobile {
            max-width: unset;
            width: 100%;
            height: 400px;
        }
    }

    &--background-container {
        display: block;
        width: 100%;
    }
}

@media (min-width: 768px) {
   .TP {
        width: 60%;
        margin: 0 20%;
        &--background-image {
            &--desktop {
                display: block;
                width: max-content;
                max-width: unset;
                height: 400px;
            }
            &--mobile {
                display: none;
            }
        }
   }
}

@media (min-width: 1024px) {
   .TP {
        width: 50%;
        margin: 0 25%;
    }
}

@media (min-width: 1380px) {
    .TP--background-image--desktop {
        width: 100%;
        height: auto;
    }
}
</style>
